var _defs, _rect, _ellipse, _ellipse2, _g, _g2, _path, _path2, _path3, _path4, _ellipse3, _path5, _rect2, _rect3, _rect4, _rect5, _rect6, _g3, _g4, _g5, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _rect7, _rect8, _rect9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArena(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1600 900",
    preserveAspectRatio: "xMidYMid slice",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "sg",
    cx: "72%",
    cy: "52%",
    r: "38%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#e8820a",
    stopOpacity: 0.92
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "28%",
    stopColor: "#c45a08",
    stopOpacity: 0.65
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "60%",
    stopColor: "#7a2d18",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0a1a2e",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sky",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#070d1a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "30%",
    stopColor: "#0d1e35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "60%",
    stopColor: "#112540"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "85%",
    stopColor: "#1a3348"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#1e3a40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sea",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#1a3a45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "40%",
    stopColor: "#0f2530"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#060e16"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "refl",
    cx: "68%",
    cy: "0%",
    r: "70%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#c45a08",
    stopOpacity: 0.28
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#7a3010",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0a1a2e",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("filter", {
    id: "blur3",
    x: "-20%",
    y: "-20%",
    width: "140%",
    height: "140%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  })), /*#__PURE__*/React.createElement("filter", {
    id: "blur8",
    x: "-20%",
    y: "-20%",
    width: "140%",
    height: "140%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  })), /*#__PURE__*/React.createElement("filter", {
    id: "blur16",
    x: "-30%",
    y: "-30%",
    width: "160%",
    height: "160%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "seaClip"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 560,
    width: 1600,
    height: 340
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1600,
    height: 900,
    fill: "url(#sky)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1105,
    cy: 465,
    rx: 320,
    ry: 260,
    fill: "url(#sg)",
    filter: "url(#blur16)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1105,
    cy: 465,
    rx: 160,
    ry: 130,
    fill: "#e8820a",
    fillOpacity: 0.18,
    filter: "url(#blur8)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#c8d8e8",
    fillOpacity: 0.7
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 28,
    r: 0.9
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 118,
    cy: 55,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 18,
    r: 1.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 310,
    cy: 42,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 380,
    cy: 12,
    r: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 450,
    cy: 68,
    r: 0.9
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 530,
    cy: 25,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 610,
    cy: 48,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 680,
    cy: 15,
    r: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 110,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 155,
    cy: 88,
    r: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 240,
    cy: 130,
    r: 0.9
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 350,
    cy: 95,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 420,
    cy: 140,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 500,
    cy: 80,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 580,
    cy: 115,
    r: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 640,
    cy: 75,
    r: 0.9
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 720,
    cy: 105,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 175,
    r: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 130,
    cy: 195,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 220,
    cy: 165,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 295,
    cy: 210,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 405,
    cy: 185,
    r: 0.9
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 490,
    cy: 220,
    r: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 560,
    cy: 160,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 650,
    cy: 200,
    r: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 740,
    cy: 175,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 800,
    cy: 60,
    r: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 850,
    cy: 30,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 250,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 165,
    cy: 270,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 335,
    cy: 255,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 475,
    cy: 285,
    r: 0.6
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#e8d0a8",
    fillOpacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 88,
    cy: 35,
    r: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 270,
    cy: 22,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 445,
    cy: 50,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 595,
    cy: 38,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 178,
    cy: 148,
    r: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 370,
    cy: 118,
    r: 0.5
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,520 L80,410 L160,460 L250,370 L340,430 L420,390 L500,460 L600,440 L700,520 L0,520Z",
    fill: "#0a1828",
    fillOpacity: 0.85
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M900,520 L980,450 L1060,490 L1160,420 L1260,470 L1350,440 L1500,510 L1600,500 L1600,520Z",
    fill: "#0c1e30",
    fillOpacity: 0.7
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M980,560 Q1020,500 1060,480 L1080,440 L1100,420 Q1110,400 1120,380 L1140,340 Q1145,310 1150,290 L1160,260 L1165,235 L1170,210 L1175,185 L1180,160 L1183,135 L1186,110 L1188,85 L1190,60 L1192,85 L1194,110 L1196,135 L1198,155 L1202,180 L1205,200 L1208,225 L1212,250 L1218,275 L1225,300 L1232,325 L1242,350 L1255,375 L1268,395 L1285,415 L1305,435 L1325,450 L1350,465 L1380,475 L1420,485 L1460,495 L1520,515 L1600,535 L1600,560Z",
    fill: "#070d1a"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1158,420 L1162,380 L1164,340 L1166,300 L1168,265 L1170,235 L1172,205 L1174,175 L1176,148 L1178,122 L1180,95 L1182,70 L1184,45 L1186,68 L1188,90 L1190,112 L1192,138 L1194,165 L1196,192 L1198,218 L1200,245 L1204,275 L1210,310 L1218,345 L1228,380 L1240,410 L1158,420Z",
    fill: "#050b18"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1184,
    cy: 52,
    rx: 22,
    ry: 40,
    fill: "#e8820a",
    fillOpacity: 0.22,
    filter: "url(#blur8)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1100,560 L1108,500 L1115,470 L1122,450 L1130,435 L1140,425 L1150,418 L1158,420 L1240,410 L1255,425 L1270,440 L1290,455 L1320,465 L1360,475 L1420,490 L1500,515 L1600,540 L1600,560Z",
    fill: "#060c1a"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1150,
    y: 395,
    width: 6,
    height: 30,
    fill: "#050a16"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 1232,
    y: 370,
    width: 5,
    height: 28,
    fill: "#050a16"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 1125,
    y: 418,
    width: 4,
    height: 22,
    fill: "#050a16"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 555,
    width: 1600,
    height: 345,
    fill: "url(#sea)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 555,
    width: 1600,
    height: 345,
    fill: "url(#refl)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#blur8)",
    clipPath: "url(#seaClip)",
    opacity: 0.45
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1100,580 L1108,620 L1115,650 L1122,670 L1130,685 L1150,692 L1158,690 L1240,680 L1270,668 L1320,658 L1360,648 L1420,638 L1600,610 L1600,580Z",
    fill: "#0a1828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1158,580 L1162,620 L1166,660 L1170,695 L1174,725 L1178,752 L1182,730 L1186,705 L1190,678 L1194,648 L1198,618 L1202,590 L1158,580Z",
    fill: "#060c1a"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    stroke: "#c86010",
    strokeOpacity: 0.12,
    strokeWidth: 1,
    filter: "url(#blur3)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 900,
    y1: 590,
    x2: 1400,
    y2: 590
  }), /*#__PURE__*/React.createElement("line", {
    x1: 850,
    y1: 610,
    x2: 1450,
    y2: 610
  }), /*#__PURE__*/React.createElement("line", {
    x1: 880,
    y1: 632,
    x2: 1420,
    y2: 632
  }), /*#__PURE__*/React.createElement("line", {
    x1: 860,
    y1: 655,
    x2: 1380,
    y2: 655
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    fill: "#07101e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M180,548 L175,545 L185,545 L190,548Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181,
    y: 530,
    width: 1,
    height: 15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178,538 L181,530 L184,538Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350,543 L344,540 L358,540 L362,543Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 351,
    y: 522,
    width: 1.5,
    height: 18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347,534 L351,522 L356,534Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520,546 L515,543 L528,543 L532,546Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 521,
    y: 526,
    width: 1,
    height: 17
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518,536 L521,526 L525,536Z"
  }))), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 800,
    cy: 560,
    rx: 900,
    ry: 35,
    fill: "#2a5560",
    fillOpacity: 0.28,
    filter: "url(#blur8)"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 800,
    cy: 575,
    rx: 850,
    ry: 28,
    fill: "#1e4450",
    fillOpacity: 0.2,
    filter: "url(#blur8)"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 400,
    cy: 620,
    rx: 500,
    ry: 30,
    fill: "#1e4050",
    fillOpacity: 0.18,
    filter: "url(#blur8)"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1300,
    cy: 640,
    rx: 400,
    ry: 25,
    fill: "#1a3845",
    fillOpacity: 0.15,
    filter: "url(#blur8)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 780,
    width: 1600,
    height: 120,
    fill: "#04080f",
    fillOpacity: 0.55
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 320,
    height: 900,
    fill: "#040a14",
    fillOpacity: 0.38
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1600,
    height: 80,
    fill: "#050c18",
    fillOpacity: 0.55
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArena);
export default __webpack_public_path__ + "static/media/arena.2b61f750b94f910925cc7231886deebd.svg";
export { ForwardRef as ReactComponent };